import { z } from 'zod'

export const JudicialRecordSoquijProvincialSearchCriteriaZod = z
  .object({
    Nom: z.string(),
    Prenom: z.string(),
    RaisonSocial: z.string(),
    Constat: z.string(),
    Parties: z.string(),
    District: z.string(),
    Juridiction: z.string(),
    Nature: z.string(),
    Naissance: z.string(),
    AnneeDebut: z.string(),
    AnneeFin: z.string(),
    Type: z.string(),
  })
  .partial()

export const JudicialRecordSoquijMunicipalSearchCriteriaZod = z
  .object({
    Nom: z.string(),
    Prenom: z.string(),
    AnneeDebut: z.number(),
    AnneeFin: z.number(),
    CodeTypePoursuite: z.string(),
  })
  .partial()

const JudicialRecordSoquijStatusZod = z.enum(['En cours', 'Terminé', 'Erreur', 'Query'])

export const JudicialRecordSoquijSearchRequestZod = z.discriminatedUnion('type', [
  z.object({
    type: z.enum(['provincial']),
    criteria: JudicialRecordSoquijProvincialSearchCriteriaZod,
    statut: JudicialRecordSoquijStatusZod,
    nombreDeResultats: z.number().optional(),
    transaction: z.string().optional(),
    dateEcheance: z.date().optional(),
    retrievedAt: z.date().optional(),
    retryCount: z.number().optional(),
  }),
  z.object({
    type: z.enum(['municipal']),
    criteria: JudicialRecordSoquijMunicipalSearchCriteriaZod,
    statut: JudicialRecordSoquijStatusZod,
    nombreDeResultats: z.number().optional(),
    transaction: z.string().optional(),
    dateEcheance: z.date().optional(),
    retrievedAt: z.date().optional(),
    retryCount: z.number().optional(),
  }),
])

export const JudicialRecordSoquijProvincialSearchResultZod = z.object({
  cleDossier: z.string(),
  demandeur: z.string(),
  defendeur: z.string(),
  dateDeNaissance: z.string().nullish(),
  dateDeNaissanceAsDate: z.string().nullish(),
})

export const JudicialRecordSoquijMunicipalSearchResultZod = z.object({
  anneeOuverture: z.string(),
  cleDossier: z.string(),
  nomPrenom: z.string(),
  dateNaissance: z.string(),
  dateInfraction: z.string(),
  numConstat: z.string(),
  statut: z.string(),
  cour: z.string(),
  juridiction: z.string(),
})
